var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bottom-banner m-btn",on:{"click":function($event){$event.stopPropagation();return _vm.openModal(_vm.MODAL_TYPES.summerGift)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }